// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bi-layout-drag-handle[data-v-5d0bc8a8] {
  z-index: 9;
  height: 12px;
  cursor: grab;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  color: rgba(0, 0, 0, 0.45);
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  align-items: center;
  justify-items: center;
  width: 28px;
  display: grid;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  top: 0;
  display: none;
}
.bi-layout-drag-handle > div[data-v-5d0bc8a8] {
  height: 5px;
  text-align: center;
}
.bi-layout-drag-handle > div .el-icon-more[data-v-5d0bc8a8] {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.vue-grid-item:hover .bi-layout-drag-handle[data-v-5d0bc8a8] {
  display: block;
}
.root-container[data-v-5d0bc8a8] {
  height: 100%;
  width: 100%;
  position: relative;
  overflow-y: auto;
  scrollbar-gutter: stable;
  user-select: none;
  margin: auto;
  box-shadow: 0 2px 4px 0 rgb(0 0 0%);
  grid-auto-rows: minmax(25px, 25px) !important;
}
.root-container .gap[data-v-5d0bc8a8] {
  height: 300px;
}
.root-container .grid-warp[data-v-5d0bc8a8] {
  border: 1px solid transparent;
  padding: 8px;
}
.root-container .grid-warp[data-v-5d0bc8a8]:hover {
  box-shadow: 0 6px 10px 0 #d8d7dc;
}
.root-container .gridlayout[data-v-5d0bc8a8] {
  height: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/canvasPanel.vue","webpack://./canvasPanel.vue"],"names":[],"mappings":"AA4KA;EACE,UAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,0BAAA;EACA,gBAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,aAAA;EACA,yCAAA;EACA,MAAA;EACA,aAAA;AC3KF;AD0JA;EAoBI,WAAA;EACA,kBAAA;AC3KJ;ADsJA;EAuBM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AC1KN;AD+KA;EAEI,cAAA;AC9KJ;ADkLA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;EACA,YAAA;EACA,mCAAA;EACA,6CAAA;AChLF;ADuKA;EAWI,aAAA;AC/KJ;ADoKA;EAcI,6BAAA;EACA,YAAA;AC/KJ;ADiLI;EACE,gCAAA;AC/KN;AD6JA;EAuBI,uBAAA;ACjLJ","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.bi-layout-drag-handle {\n  z-index: 9;\n  height: 12px;\n  cursor: grab;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: rgba(0, 0, 0, .45);\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, .12);\n  border-radius: 8px;\n  align-items: center;\n  justify-items: center;\n  width: 28px;\n  display: grid;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, .1);\n  top: 0;\n  display: none;\n\n  >div {\n    height: 5px;\n    text-align: center;\n    .el-icon-more{\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 100%;\n      width: 100%;\n    }\n  }\n}\n\n.vue-grid-item:hover {\n  .bi-layout-drag-handle {\n    display: block;\n  }\n}\n\n.root-container {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  overflow-y: auto;\n  scrollbar-gutter: stable;\n  user-select: none;\n  margin: auto;\n  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 30%);\n  grid-auto-rows: minmax(25px, 25px) !important;\n  .gap {\n    height: 300px;\n  }\n  .grid-warp {\n    border: 1px solid transparent;\n    padding: 8px;\n\n    &:hover {\n      box-shadow: 0 6px 10px 0 #d8d7dc;\n    }\n  }\n\n  .gridlayout {\n    height: 100% !important;\n  }\n}\n",".bi-layout-drag-handle {\n  z-index: 9;\n  height: 12px;\n  cursor: grab;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: rgba(0, 0, 0, 0.45);\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 8px;\n  align-items: center;\n  justify-items: center;\n  width: 28px;\n  display: grid;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);\n  top: 0;\n  display: none;\n}\n.bi-layout-drag-handle > div {\n  height: 5px;\n  text-align: center;\n}\n.bi-layout-drag-handle > div .el-icon-more {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n.vue-grid-item:hover .bi-layout-drag-handle {\n  display: block;\n}\n.root-container {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  overflow-y: auto;\n  scrollbar-gutter: stable;\n  user-select: none;\n  margin: auto;\n  box-shadow: 0 2px 4px 0 rgb(0 0 0%);\n  grid-auto-rows: minmax(25px, 25px) !important;\n}\n.root-container .gap {\n  height: 300px;\n}\n.root-container .grid-warp {\n  border: 1px solid transparent;\n  padding: 8px;\n}\n.root-container .grid-warp:hover {\n  box-shadow: 0 6px 10px 0 #d8d7dc;\n}\n.root-container .gridlayout {\n  height: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
